export const mutations = {
    SET_WEBTHEME_PARAMETERS(state, webThemeParameters) {
        state.webThemeParameters = webThemeParameters;
    },
    ADD_WEBTHEME(state, webThemeData) {
        state.webTheme = {
            id: webThemeData.id,
            data: webThemeData,
        };
    }
};
